import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const SubTitle = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: ${({ theme }) => theme.tags.tagEditModal.subTitle.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const InputWrapper = styled(FlexBox)`
    flex-flow: column;
    justify-content: flex-start;
    width: 100%;
    textarea {
        overflow: auto;
        min-height: 153px !important;
        height: 100%;
        width: 100%;
        background-color: ${({ theme }) => theme.tags.tagEditModal.input.bg};
        border-radius: 3px;
        padding: 14px 16px;
        font-size: 15px;
        line-height: 20px;
        color: ${({ theme }) => theme.tags.tagEditModal.input.color};
        border-color: transparent;
        &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            min-height: 127px !important;
            font-size: 13px;
            line-height: 16px;
        }

        @media (max-width: ${LayoutConst.screen.m}px) {
         min-height: 93px !important;
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            min-height: 271px !important;
        }

        &::placeholder {
            color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder} !important;
        }

    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 100%;
        min-width: 100%;
        width: 100%;
    }
`;

export const ModalInnerContainer = styled(FlexBox)`
    width: ${LayoutConst.container.l}px;
    margin: 0 auto;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 888px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        width: ${LayoutConst.container.xs}px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100% - 20px);
    }
`;

export const TwoColumnLayout = styled(FlexBox)`
    width: 100%;
    gap: 48px;
    
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        gap: 32px;
    }
    
    @media (max-width: ${LayoutConst.screen.m}px) {
        flex-direction: column;
        gap: 24px;
    }
`;

export const LeftColumn = styled(FlexBox)`
    flex: 1;
    min-width: 0;
    flex-direction: column;
    gap: 24px;
`;

export const RightColumn = styled(FlexBox)`
    flex: 1;
    min-width: 0;
    flex-direction: column;
    gap: 24px;
`;

export const ContextSection = styled(FlexBox)`
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    background-color: ${({ theme }) => theme.tags.tagEditModal.input.bg};
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.tags.tagEditModal.input.border || '#e0e0e0'};
`;

export const ContextHeader = styled(FlexBox)`
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.tags.tagEditModal.input.border || '#e0e0e0'};
`;

export const ContextDropdown = styled.div`
    position: relative;
    width: 100%;
`;

export const DropdownButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background-color: white;
    border: 1px solid ${({ theme }) => theme.tags.tagEditModal.input.border || '#e0e0e0'};
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: ${({ theme }) => theme.tags.tagEditModal.input.color};
    
    &:hover {
        border-color: ${({ theme }) => theme.tags.tagEditModal.input.borderHover || '#007bff'};
    }
`;

export const DropdownArrow = styled.div`
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #666;
    margin-left: 8px;
`;

export const DeleteButtonContainer = styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;

    @media (max-width: ${LayoutConst.screen.md}px) {
        left: auto;
        right: 0;
    }
`;

export const ContextLeftColumn = styled.div`
    width: 100%;
    max-width: 270px;
    position: relative;
    display: flex;
    flex-direction: column;

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const CanonicalDomainHeader = styled(FlexBox)`
    position: relative;
    width: 100%;
    max-width: 270px;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const ContextTagsContainer = styled(FlexBox)`
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 18px;
    overflow: auto;
    max-height: 280px;

    .pure-tag{
        max-width: 280px;
        div span{
        max-width: 190px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
    }

    &::-webkit-scrollbar {
        width: 4px;
        height: 42px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #909090;
        border: 1.55px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #707070;
    }
`;import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const SubTitle = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: ${({ theme }) => theme.tags.tagEditModal.subTitle.color};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const InputWrapper = styled(FlexBox)`
    flex-flow: column;
    justify-content: flex-start;
    width: 100%;
    textarea {
        overflow: auto;
        min-height: 153px !important;
        height: 100%;
        width: 100%;
        background-color: ${({ theme }) => theme.tags.tagEditModal.input.bg};
        border-radius: 3px;
        padding: 14px 16px;
        font-size: 15px;
        line-height: 20px;
        color: ${({ theme }) => theme.tags.tagEditModal.input.color};
        border-color: transparent;
        &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            min-height: 127px !important;
            font-size: 13px;
            line-height: 16px;
        }

        @media (max-width: ${LayoutConst.screen.m}px) {
         min-height: 93px !important;
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            min-height: 271px !important;
        }

        &::placeholder {
            color: ${({ theme }) => theme.competitionLegalsModal.input.placeholder} !important;
        }

    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 100%;
        min-width: 100%;
        width: 100%;
    }
`;

export const ModalInnerContainer = styled(FlexBox)`
    width: ${LayoutConst.container.l}px;
    margin: 0 auto;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 888px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        width: ${LayoutConst.container.xs}px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100% - 20px);
    }
`;

export const TwoColumnLayout = styled(FlexBox)`
    width: 100%;
    gap: 48px;
    
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        gap: 32px;
    }
    
    @media (max-width: ${LayoutConst.screen.m}px) {
        flex-direction: column;
        gap: 24px;
    }
`;

export const LeftColumn = styled(FlexBox)`
    flex: 1;
    min-width: 0;
    flex-direction: column;
    gap: 24px;
`;

export const RightColumn = styled(FlexBox)`
    flex: 1;
    min-width: 0;
    flex-direction: column;
    gap: 24px;
`;

export const ContextSection = styled(FlexBox)`
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    background-color: ${({ theme }) => theme.tags.tagEditModal.input.bg};
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.tags.tagEditModal.input.border || '#e0e0e0'};
`;

export const ContextHeader = styled(FlexBox)`
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.tags.tagEditModal.input.border || '#e0e0e0'};
`;

export const ContextDropdown = styled.div`
    position: relative;
    width: 100%;
`;

export const DropdownButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background-color: white;
    border: 1px solid ${({ theme }) => theme.tags.tagEditModal.input.border || '#e0e0e0'};
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: ${({ theme }) => theme.tags.tagEditModal.input.color};
    
    &:hover {
        border-color: ${({ theme }) => theme.tags.tagEditModal.input.borderHover || '#007bff'};
    }
`;

export const DropdownArrow = styled.div`
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #666;
    margin-left: 8px;
`;

export const DeleteButtonContainer = styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;

    @media (max-width: ${LayoutConst.screen.md}px) {
        left: auto;
        right: 0;
    }
`;

export const ContextLeftColumn = styled.div`
    width: 100%;
    max-width: 270px;
    position: relative;
    display: flex;
    flex-direction: column;

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const CanonicalDomainHeader = styled(FlexBox)`
    position: relative;
    width: 100%;
    max-width: 270px;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const ContextTagsContainer = styled(FlexBox)`
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 18px;
    overflow: auto;
    max-height: 280px;

    .pure-tag{
        max-width: 280px;
        div span{
        max-width: 190px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
    }

    &::-webkit-scrollbar {
        width: 4px;
        height: 42px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #909090;
        border: 1.55px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #707070;
    }
`;